export const taskDone = (fn, time, id) => {
  const timers = {}
  if (typeof fn === 'function') {
    if (timers[id]) clearTimeout(timers[id])
    timers[id] = setTimeout(fn, time)
  }
}

/**
 * Announces a message to screen readers by updating the aria-announce element.
 * This helper function is used for accessibility purposes to notify users of updates.
 *
 * @param {string} msg - The message to announce
 * @param {HTMLElement} form - Optional form element to focus invalid field
 * @param {HTMLElement} ele - Optional element to append its text content to message
 * @param {number} delay - Optional delay before announcement (defaults to 500ms)
 */
export const announce = (msg, form, ele, delay) => {
  let message = msg
  if (typeof ele === 'object') {
    message += ele.innerText.replace(/\n/g, ' ')
  }
  if (document) {
    if (document.getElementById('aria-announce')) {
      document.getElementById('aria-announce').innerHTML = ''
    }
    taskDone(
      () => {
        if (document.getElementById('aria-announce')) {
          document.getElementById('aria-announce').innerHTML = message
        }
      },
      delay || 500,
      'announceMessage',
    )
    if (form) {
      taskDone(
        () => {
          form.querySelectorAll('[aria-invalid="true"]')[0].focus()
        },
        1000,
        'focusElement',
      )
    }
  }
}
